import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { PasswordService } from '../../services/password.service';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpError } from '../../../http/httpError';
import { LoadingDirective } from '@styleguide/loading/loading.directive';

import { ErrorsComponent } from '@styleguide/error/errors/errors.component';
import { FormFieldComponent } from '@styleguide/form/form-field/form-field.component';

enum ComponentStates {
  idle,
  loading,
}

@Component({
  selector: 'kgr-password-request-reset',
  templateUrl: './password-request-reset.component.html',
  styleUrls: ['./password-request-reset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingDirective, ErrorsComponent, ReactiveFormsModule, FormsModule, FormFieldComponent],
})
export class PasswordRequestResetComponent implements OnInit {
  readonly ComponentStates = ComponentStates;

  @Output() done = new EventEmitter<void>();

  apiError: HttpError;
  control: UntypedFormControl;
  hasErrors: boolean;

  state = signal<ComponentStates>(ComponentStates.idle);

  constructor(
    private passwordService: PasswordService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.control = new UntypedFormControl(this.route.snapshot.params['email'] || '', [Validators.required, Validators.email]);
    this.control.valueChanges.subscribe(() => {
      this.hasErrors = false;
      this.apiError = null;
    });
  }

  onSubmit() {
    if (!this.control.valid) {
      this.hasErrors = true;
      return;
    }
    if (this.state() !== ComponentStates.loading) {
      this.state.set(ComponentStates.loading);
      this.apiError = null;
      this.hasErrors = false;
      this.passwordService.requestReset(this.control.value).subscribe(
        () => {
          this.done.emit();
        },
        (apiError: HttpError) => {
          this.apiError = apiError;
          this.state.set(ComponentStates.idle);
        },
      );
    }
  }
}
